var _a, _b;
export var LangEnum;
(function (LangEnum) {
    LangEnum["fr"] = "fr";
    LangEnum["en"] = "en";
    LangEnum["it"] = "it";
    LangEnum["es"] = "es";
    LangEnum["de"] = "de";
})(LangEnum || (LangEnum = {}));
export var LocaleEnum;
(function (LocaleEnum) {
    LocaleEnum["fr_FR"] = "fr_FR";
    LocaleEnum["en_GB"] = "en_GB";
    LocaleEnum["it_IT"] = "it_IT";
    LocaleEnum["es_ES"] = "es_ES";
    LocaleEnum["de_DE"] = "de_DE";
})(LocaleEnum || (LocaleEnum = {}));
export var DEFAULT_LOCALE_BY_LANGUAGE = (_a = {},
    _a[LangEnum.fr] = LocaleEnum.fr_FR,
    _a[LangEnum.en] = LocaleEnum.en_GB,
    _a[LangEnum.it] = LocaleEnum.it_IT,
    _a[LangEnum.es] = LocaleEnum.es_ES,
    _a[LangEnum.de] = LocaleEnum.de_DE,
    _a);
export var DEFAULT_LANGUAGE_BY_LOCALE = (_b = {},
    _b[LocaleEnum.fr_FR] = LangEnum.fr,
    _b[LocaleEnum.en_GB] = LangEnum.en,
    _b[LocaleEnum.it_IT] = LangEnum.it,
    _b[LocaleEnum.es_ES] = LangEnum.es,
    _b[LocaleEnum.de_DE] = LangEnum.de,
    _b);
